module.exports = __webpack_public_path__ + "static/media/eligible_edit.ddf1ea75.svg";